import { formatDate, differenceInYears } from '@thrivadev/thriva-date-utils'

export default {
  formatDate: value => {
    if (!value) {
      return
    }
    return formatDate(new Date(value), 'dd/MM/yyyy')
  },
  currentAge: value => {
    if (!value) {
      return
    }
    return differenceInYears(new Date(), new Date(value))
  },
  formatPrice: value => {
    if (!value) {
      return ''
    }
    let afterDecimal = value % 100
    const beforeDecimal = (value - (value % 100)) / 100
    if (afterDecimal < 10) {
      afterDecimal = '0' + afterDecimal
    }
    return beforeDecimal.toString() + '.' + afterDecimal
  },
  formatCurrency: (pricePence, options = {}) => {
    if (!['string', 'number'].includes(typeof pricePence)) {
      return ''
    }
    const pounds = pricePence / 100
    return pounds.toLocaleString('en-gb', {
      style: 'currency',
      currency: 'GBP',
      maximumFractionDigits: options.stripFraction && pounds % 1 === 0 ? 0 : 2
    })
  },
  formatAddress: value => {
    return Object.values(value).filter(Boolean).join(', ')
  },
  capitalize: value => {
    if (!value) {
      return ''
    }
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  },
  lowerCase: value => {
    if (!value) {
      return ''
    }
    return value.toString().toLowerCase()
  },
  humanize: value => {
    if (!value) {
      return ''
    }
    return value.toString().replace(/_/g, ' ')
  }
}
